import {
  Button,
  HStack,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { getTelemetriaRobo } from 'services/app';
import { ITelemetriaRobo } from 'shared/models/telemetriaRobo';
import PaginationFooter from './PaginationFooter';

interface TelemetriaRoboProps {
  clienteId: number;
}

const TelemetriaRobo: React.FC<TelemetriaRoboProps> = ({ clienteId }) => {
  const toast = useToast();
  const [telemetria, setTelemetria] = useState<ITelemetriaRobo[]>([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const handleFilter = async () => {
    setLoading(true);
    try {
      const res = await getTelemetriaRobo(clienteId);
      setTelemetria(res.data);
      setPage(1);
      setHasSearched(true);
    } catch (error) {
      toast({
        title: 'Erro ao buscar telemetria',
        status: 'error',
        duration: 3000,
      });
      setTelemetria([]);
    } finally {
      setLoading(false);
    }
  };

  const paginatedData = useMemo(() => {
    const upperLimit = pageSize * page - 1;
    const lowerLimit = pageSize * (page - 1);
    return telemetria.filter(
      (_, idx) => idx >= lowerLimit && idx <= upperLimit,
    );
  }, [telemetria, page, pageSize]);

  return (
    <Stack>
      <HStack justify="space-between">
        <Text fontWeight="500" color="gray.500">
          Histórico de consultas
        </Text>
        <Button
          size="sm"
          colorScheme="blue"
          onClick={handleFilter}
          isLoading={loading}
        >
          Filtrar últimas 24h
        </Button>
      </HStack>

      {paginatedData.length > 0 && (
        <>
          <Table size="sm" mt="1rem">
            <Thead>
              <Tr>
                <Th>Data</Th>
                <Th>Hora</Th>
                <Th>Evento</Th>
              </Tr>
            </Thead>
            <Tbody>
              {paginatedData.map((item) => (
                <Tr key={item.id}>
                  <Td>{moment(item.data).format('DD/MM/YYYY')}</Td>
                  <Td>{item.hora}</Td>
                  <Td
                    fontSize="0.8rem"
                    maxW="400px"
                    isTruncated
                    title={item.evento}
                  >
                    {item.evento}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>

          <PaginationFooter
            totalLength={telemetria.length}
            visibleLength={paginatedData.length}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        </>
      )}

      {telemetria.length === 0 && hasSearched && !loading && (
        <Text fontSize="0.8rem" color="gray.400" mt="0.5rem">
          Nenhum erro nas últimas 24h
        </Text>
      )}
    </Stack>
  );
};

export default TelemetriaRobo;
